import { render } from "./inquiry-popup-com.vue?vue&type=template&id=6c5f47f6&scoped=true"
import script from "./inquiry-popup-com.vue?vue&type=script&lang=js"
export * from "./inquiry-popup-com.vue?vue&type=script&lang=js"

import "./inquiry-popup-com.vue?vue&type=style&index=0&id=6c5f47f6&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5f47f6"]])

export default __exports__